<script>
	import { Container, Checkbox } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';

	let host = import.meta.env.VITE_APP_BUCKET || window.location.host;

	export let accepted = false;

	let isOfAge = false;
	let agreedToGTC = false;

	$: {
		accepted = isOfAge && agreedToGTC;
	}

	const isOfAgeText = $format('label_confirm_of_age', {
		default: 'I confirm that I am 16 or older',
	});
</script>

<Container padding="scrollPaddings">
	<Checkbox bind:checked={isOfAge} id="checkbox-k3epyba">{isOfAgeText}</Checkbox>
	<Checkbox bind:checked={agreedToGTC} id="checkbox-713r5ys"
		>{$format('checkbox_read_agree_terms_conditions', {
			default: 'I have read and agree to the',
		})}
		<span
			class="link-styles"
			style="font-size: inherit; line-height: inherit;"
			role="presentation"
			on:click={() => push(`/terms-and-conditions`)}
		>
			{$format('link_terms_cond', { default: 'Terms and Conditions' })}.
		</span></Checkbox
	>
</Container>
